import { TFunction } from "i18next";

import {
  getAppealStatus,
  getMalusStatus,
  getResolutionStatus,
} from "~/entity/Appeals/model/static";
import { FilterField, FilterFieldOption } from "~/features/filter";
import { getYearOptionsForSelect } from "~/libs/getDateOptions";
import { useFilterItemOptions } from "~/pages/StaffBonus/Filter/optionsHooks";
import { FILTER_BY } from "~/shared/hooks/useStaffFilterData/useStaffFilterData";
import { ISelectOption } from "~/shared/ui/Fields/types";

/** Все ключи URL, которыми владеет фильтр. */
export const APPEAL_FILTER_KEYS = [
  "year",
  "quarter",
  "malusStatus",
  "appealStatus",
  "resolutionStatus",
  "filterBy",
  "filterItems",
];

const quartersOptions = [
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
  { label: "4", value: "4" },
];

// ISelectOption из entity хранит label/value опциональными — приводим
// к обязательным строкам FilterFieldOption.
const toFilterOptions = (options: ISelectOption[]): FilterFieldOption[] =>
  options.map(({ label, value }) => ({
    label: String(label),
    value: String(value),
  }));

/**
 * Поля фильтра страницы «Статус Малуса по обучению». Имена полей совпадают
 * с URL-параметрами — значения хранятся в query-строке плоскими строками.
 * Подписи сохранены из старого конфига (widgets/Filters/AppealsFilter).
 */
export const appealsFilterFields = (t: TFunction): FilterField[] => [
  {
    name: "year",
    type: "select",
    label: "Год",
    options: getYearOptionsForSelect().map((year) => ({
      value: String(year),
      label: String(year),
    })),
  },
  {
    name: "quarter",
    type: "select",
    label: "Квартал",
    options: quartersOptions,
  },
  {
    name: "malusStatus",
    type: "select",
    label: "Статус Малуса",
    options: toFilterOptions(getMalusStatus(t)),
  },
  {
    name: "appealStatus",
    type: "select",
    label: "Статус подачи апелляции",
    options: toFilterOptions(getAppealStatus(t)),
  },
  {
    name: "resolutionStatus",
    type: "select",
    label: "Решение",
    options: toFilterOptions(getResolutionStatus(t)),
  },
  {
    name: "filterBy",
    type: "select",
    label: "Отфильтровать",
    // При смене измерения значения прошлого измерения не имеют смысла —
    // сбрасываем зависимое поле (его опции переключатся через useWatch).
    resetFieldsOnChange: ["filterItems"],
    options: [
      { value: FILTER_BY.DEALER, label: "Дилер" },
      { value: FILTER_BY.CITY, label: "Город" },
      { value: FILTER_BY.AREA, label: "Субъект" },
      { value: FILTER_BY.COUNTRY, label: "Страна" },
      { value: FILTER_BY.FO, label: "ФО" },
    ],
  },
  {
    name: "filterItems",
    type: "select",
    multiple: true,
    label: "Значения",
    // Опции зависят от filterBy: дилеры — с пагинацией/поиском,
    // локации — списками из справочника (useWatch внутри хука).
    optionsHook: useFilterItemOptions,
    span: 4,
  },
];
